// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'Common/Image';
import styles from 'components/Spinner.scss';
import spinner from './spinner.svg';

/**
 * Spinner component
 * @returns {ReactElement} the spinner component
 */
export class Spinner extends PureComponent<*, *> {
  /**
   *    Props implementation.
   */
  static propTypes = {
    classSpinner: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    src: PropTypes.string.isRequired,
    height: PropTypes.number,
    width: PropTypes.number
  };

  /**
   *    Default Props values.
   */
  static defaultProps = {
    height: 50,
    width: 50,
    src: spinner
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render() {
    const { extendStyle, src, height, width } = this.props;
    const { classSpinner } = styles;

    const spinnerStyle = {};
    spinnerStyle.height = height;
    spinnerStyle.width = width;

    return (
      <div className={classNames(extendStyle, classSpinner)}>
        <div style={spinnerStyle}>
          <Image src={src} title="Spinner" alt="Spinner" />
        </div>
      </div>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/Common/Spinner/index.js